module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921024149_T.dac197f3.jpg";